import { request } from 'utils/axios';

const login = (data) => request('post', 'auth/local', '', data);

export default login;
